import { Component, EventEmitter, Input, Output, ElementRef, HostListener } from "@angular/core";
import { Account } from "src/app/screens/user-profile/client-data";
import { FavService } from "src/app/services/fav.service";

@Component({
  selector: "app-favorite-menu",
  templateUrl: "./favorite-menu.component.html",
  styleUrls: ["./favorite-menu.component.scss"]
})
export class FavoriteMenuComponent {
  @Input() x = 0;
  @Input() y = 0;
  @Input() isShow: boolean = false;
  @Input() item: any;
  @Input() marketWatches = [];
  @Output() clickedOutside = new EventEmitter();
  @Output() addNewFavorite = new EventEmitter<{symbol: string, name: string}>();
  @Output() selectMarketWatchEvent = new EventEmitter<{watch: any,symbol:string}>();
  @Output() deleteMarketWatchEvent = new EventEmitter<{marketWatchID: string}>();
  isDarkTheme : boolean ;
  showAddFavorite: boolean = false;
  newFavoriteName: string = "";
  errorMessage: string = "";
  relationCode: any;
  accList: Account[];


  constructor(private eRef: ElementRef,
    private favService : FavService,
  ) {}
  @HostListener("document:click", ["$event"])
  clickOutside(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.clickedOutside.emit(); 
    }
  }

   toggleAddFavorite(event: MouseEvent) {
    event.stopPropagation(); 
    // if (this.marketWatches.length >= 5) {
    //   alert('You can only have 5 watchlists.');
    //   return;
    // }
    this.showAddFavorite = !this.showAddFavorite;
    this.errorMessage = '';  
  }

  preventCloseOnInternalClick(event: MouseEvent) {
    event.stopPropagation(); 
  }

  createFavorite(symbol: string) {
    // if (this.marketWatches.length >= 5) {
    //   alert('You can only have 5 watchlists.');
    //   return;
    // }

    if (this.newFavoriteName.trim()) {
    const name= this.newFavoriteName;
    this.addNewFavorite.emit({symbol,name});
    this.newFavoriteName = "";
    this.showAddFavorite = false;
    }
    else{
      alert('Please enter a name for the new favorite list.');

    }
  }

  selectMarketWatch(watch:any, symbol: string) {  
    this.selectMarketWatchEvent.emit({ watch, symbol });
  }

  deleteMarketWatch(marketWatchID: string) {
    this.deleteMarketWatchEvent.emit({marketWatchID});
  }


  ngOnInit() {
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false;
      this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
      this.relationCode = this.accList?.[0]?.relationCode ?? '';
      if(this.marketWatches.length === 0 || this.marketWatches == null || this.marketWatches == undefined || !this.marketWatches) 
        {
           this.loadMarketWatches();
        }

  }
  
  loadMarketWatches() {
    this.favService.getMarketWatchList(this.relationCode).subscribe(watches => {
      this.marketWatches = watches;
  
      // fetch symbols for each watch
      this.marketWatches.forEach(watch => {
        this.favService.getMarketWatchSymbols(watch.MarketWatchID, this.relationCode)
          .subscribe(symbols => {
            watch.symbols = symbols;  // attach symbols
          });
      });
    });
  }
  
  isSymbolInWatch(symbol: string, watch: any): boolean {
    return watch.symbols?.includes(symbol);
  }
}
